module.exports = __webpack_public_path__ + "static/media/pin-dark.fa79278a.svg";